export default {
    namespaced: true,

    state: {
        areas: [],
        areaIds: [],
        activeAreas: [],
        areaHeader: "",
        areaEnabled: false
    },

    mutations: {
        toggleAreaIds(state, status) {
            if (!state.areaIds.includes(status)) {
                state.areaIds.push(status);
            } else if (state.areaIds.includes(status)) {
                state.areaIds = state.areaIds.filter(el => el !== status);
            }
        },
        toggleCheckedArea(state, area) {
            state.activeAreas.filter(activeArea => {
                if (activeArea.Key === area) {
                    activeArea.checked = !activeArea.checked;
                }
            });
        },
        setAreaData(state, rootState) {
            state.areas = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("Areas");
                })
                .map(filtered => {
                    return filtered.Areas;
                })[0];


            state.areaHeader = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("AreaHeader");
                })
                .map(filtered => {
                    return filtered.AreaHeader;
                })[0];

            if (state.areas && state.areas.length > 0) {
                state.areaEnabled = true;
            }

            if (state.areaenabled) {
                if (rootState.locations.locations) {
                    state.activeAreas = state.areas.filter(area => {
                            if (
                                rootState.locations.activeLocations.includes(area.ParentKey)
                            ) {
                                return area;
                            }
                        })
                        .map(filtered => {
                            let obj = {};
                            if (filtered.KeyValuePair) {
                                obj.Key = filtered.KeyValuePair.Key;
                                obj.Value = filtered.KeyValuePair.Value;
                                obj.checked = false;
                            }

                            return obj;
                        });
                } else {
                    state.activeAreas = state.attractions
                        .filter(attraction => {
                            return attraction.hasOwnProperty("Areas");
                        })
                        .map(filtered => {
                            return filtered.Areas;
                        })[0];
                }
            }
        },
        setAreaValuesFromCookie(state, payload) {
            if (payload.areas) {
                state.areaIds = payload.areas;
            }
        },
        updateAreas(state, rootState) {
            if (state.areaEnabled) {
                state.activeAreas = state.areas
                    .filter(area => {
                        if (rootState.locations.activeLocations.includes(area.ParentKey)) {
                            return area;
                        }
                    })
                    .map(filtered => {
                        let obj = {};
                        if (filtered.KeyValuePair) {
                            obj.Key = filtered.KeyValuePair.Key;
                            obj.Value = filtered.KeyValuePair.Value;
                            obj.checked = false;
                        }
                        return obj;
                    });
            }
        }
    },

    actions: {
        resetAreas({ state, rootState }) {
            if (rootState.locations.locations && state.areas) {
                state.activeAreas = state.areas
                    .filter(area => {
                        return area.ParentKey === rootState.locations.locations[0].Key;
                    })
                    .map(filtered => {
                        let obj = {};
                        obj.Key = filtered.KeyValuePair.Key;
                        obj.Value = filtered.KeyValuePair.Value;
                        obj.checked = false;
                        return obj;
                    });
            } else {
                state.activeAreas = rootState.attractions
                    .filter(attraction => {
                        return attraction.hasOwnProperty("Areas");
                    })
                    .map(filtered => {
                        return filtered.Areas;
                    })[0];
            }

            state.areaIds = [];
        },
    },

    getters: {
        getAreasByParentKey: state => parentkey => {
            return state.areas.filter(area => {
                return area.ParentKey == parentkey;
            });
        }
    }
};
